/**
 * @class ProductRecommendations
 * @classdesc The Product Recommendations class handles loading in the recommended products.
 * @extends Core.SectionComponent
 */
export default class ProductRecommendations extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    // We want to start loading the products when the user has scrolled within 200px of the section.
    new IntersectionObserver(this._handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(el);
  }

  /**
   *
   * Monitors and loads the recommended products if scrolled within 200px of the section
   * @param {IntersectionObserverEntry[]} entries - This Intersection Observer API interface
   * describes the intersection between the target element and its root container at a specific
   * moment of transition.
   * @param {IntersectionObserver} observer - provides a way to asynchronously observe changes
   * in the intersection of a target element with an ancestor element or with a top-level
   * document's viewport.
   * @private
   */
  _handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this.el);

    fetch(this.data.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.el.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
